import React from "react";
var __jsx = React.createElement;
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
var CarInfoShimmer = function CarInfoShimmer(_ref) {
  var variant = _ref.variant;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-lg w-full",
    dir: "rtl"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-lg shadow-md border border-gray-100 overflow-hidden"
  }, variant === 'full' && /*#__PURE__*/React.createElement("div", {
    className: "px-8 py-4 flex justify-between items-center gap-2"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 120,
    appearance: {
      color: "blue"
    }
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 120,
    appearance: {
      color: "blue"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 144,
    appearance: {
      color: "gray"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 128,
    appearance: {
      color: "green"
    }
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 16,
    divWidth: 64,
    className: "mt-1",
    appearance: {
      color: "green"
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-2 mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 144,
    appearance: {
      color: "gray"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 128,
    appearance: {
      color: "green"
    }
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 16,
    divWidth: 64,
    className: "mt-1",
    appearance: {
      color: "green",
      opacity: "light"
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "bg-blue-50 py-1 flex justify-center items-center"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 24,
    divWidth: 144,
    appearance: {
      color: "gray"
    }
  })))));
};
export default CarInfoShimmer;